module.exports = __webpack_public_path__ + "img/layanan-barang.f055483d.webp";